import { Phone, Mail } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { useBranding } from '@/shared/contexts/BrandingContext';

interface BrandContactBarProps {
  onQuoteClick: () => void;
}

export default function BrandContactBar({ onQuoteClick }: BrandContactBarProps) {
  const { isAegis360, isGreenshield } = useBranding();

  if (isGreenshield) {
    return (
      <div className="bg-green-700 text-white py-2 px-4">
        <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center text-sm gap-2">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4" />
              <span>Have a pest problem? Call: 07913024492</span>
            </div>
            <Button 
              variant="outline" 
              size="sm" 
              className="text-green-700 border-white bg-white hover:bg-gray-100"
              onClick={onQuoteClick}
            >
              QUOTE
            </Button>
          </div>
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4" />
              <span>General enquiry: 07913024492</span>
            </div>
            <div className="flex items-center space-x-2 cursor-pointer hover:text-green-200">
              <Mail className="h-4 w-4" />
              <span>info@greenshieldpestmanagement.co.uk</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isAegis360) {
    return (
      <div className="bg-blue-700 text-white py-2 px-4">
        <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center text-sm gap-2">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4" />
              <span>Transform your pest control business with AI</span>
            </div>
            <Button 
              variant="outline" 
              size="sm" 
              className="text-blue-700 border-white bg-white hover:bg-gray-100"
              onClick={() => window.location.href = '/book-demo'}
            >
              REQUEST DEMO
            </Button>
          </div>
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4" />
              <span>Sales enquiry: +44-800-AEGIS360</span>
            </div>
            <div className="flex items-center space-x-2 cursor-pointer hover:text-blue-200">
              <Mail className="h-4 w-4" />
              <span>sales@aegis360.co.uk</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}